import { SettingsTakeover } from 'modules/journey/components/SettingsTakeover';
import { RevisionHistoryTakeover } from '../JourneyRevisionHistory';
import { NodeVisitorsTakeover } from '../NodeVisitorsTakeover';
import { ScheduledJourneyAdditionalCriteriaTakeover } from './ScheduledJourneyAdditionalCriteriaTakeover';
import { JourneyVisitorBreakdownTakeover } from './JourneyVisitorBreakdownTakeover/JourneyVisitorBreakdownTakeover';

export enum TakeoverType {
  NodeVisitors = 'NodeVisitors',
  Settings = 'Settings',
  RevisionHistory = 'RevisionHistory',
  ScheduledJourneyAdditionalCriteria = 'ScheduledJourneyAdditionalCriteria',
  JourneyVisitorBreakdown = 'JourneyVisitorBreakdown',
}

export const TAKEOVER_COMPONENTS: Record<TakeoverType, (args: any) => JSX.Element> = {
  [TakeoverType.Settings]: SettingsTakeover,
  [TakeoverType.RevisionHistory]: RevisionHistoryTakeover,
  [TakeoverType.NodeVisitors]: NodeVisitorsTakeover,
  [TakeoverType.ScheduledJourneyAdditionalCriteria]: ScheduledJourneyAdditionalCriteriaTakeover,
  [TakeoverType.JourneyVisitorBreakdown]: JourneyVisitorBreakdownTakeover,
};
